export enum CaseParticipantGroup {
  Normal = 0,
  Cc = 1,
  Other = 2,
}
